var SENTRY_RELEASE;SENTRY_RELEASE={name: "Storecast TV", version: "1.0.0"};